/**
 * Calculates the "active" duration of a tally — total elapsed time minus
 * any time spent on hold. Returns a formatted string like "1h 24m 08s".
 *
 * @param {Object} tally
 * @param {string|Date} tally.startedAt
 * @param {string|Date} [tally.completedAt]
 * @param {boolean} [tally.isOnHold]
 * @param {string|Date} [tally.pausedAt]
 * @param {number} [tally.totalPausedMs]
 * @returns {string}
 */
export const calcActiveDuration = (tally) => {
  if (!tally?.startedAt) return "0h 0m 00s";

  const endTime = tally.completedAt ? new Date(tally.completedAt) : new Date();
  const totalMs = endTime - new Date(tally.startedAt);

  let pausedMs = tally.totalPausedMs ?? 0;
  if (tally.isOnHold && tally.pausedAt) {
    pausedMs += Date.now() - new Date(tally.pausedAt).getTime();
  }

  const activeMs = Math.max(0, totalMs - pausedMs);

  const hours = Math.floor(activeMs / 3600000);
  const minutes = Math.floor((activeMs % 3600000) / 60000);
  const seconds = Math.floor((activeMs % 60000) / 1000);

  return `${hours}h ${minutes}m ${String(seconds).padStart(2, "0")}s`;
};
